import { CASH_REGISTER_FORM_MAX_QUESTIONS } from "@ac-expo/utils";
import { z } from "zod";

const questionOnEventSchema = z.object({
  questionId: z.string().min(1),
  order: z.number().int().min(0),
});

export const eventFormQuestionsOnEventSchema = z.object({
  questions: z.array(questionOnEventSchema),
});

export const cashRegisterFormQuestionsOnEventSchema = z.object({
  questions: z
    .array(questionOnEventSchema)
    .max(
      CASH_REGISTER_FORM_MAX_QUESTIONS,
      `${CASH_REGISTER_FORM_MAX_QUESTIONS} questions maximum au guichet`
    ),
});

export type EventFormQuestionsOnEventForm = z.infer<
  typeof eventFormQuestionsOnEventSchema
>;

export const defaultEventFormQuestionsOnEventValues: EventFormQuestionsOnEventForm =
  {
    questions: [],
  };
